import React from "react";
import { RouteProps } from "react-router-dom";
import { adminDashboardMenu, demoPagesMenu, authPages } from "../menu";
import DefaultFooter from "../pages/_layout/_footers/DefaultFooter";

const footers: RouteProps[] = [
  { path: authPages.login.path, element: null },
  { path: demoPagesMenu.signUp.path, element: null },
  { path: demoPagesMenu.page404.path, element: null },
  { path: authPages.setpassword.path, element: null },
  { path: authPages.forgotpassword.path, element: null },
  { path: authPages.payinvoice.path, element: null },
  { path: authPages.PaymentFormEbutton.path, element: null },
  { path: authPages.paymentsuccess.path, element: null },
   { path: authPages.PaymentLinkNotFound.path, element: null },
  { path: authPages.Page404.path, element: null },
  { path: authPages.NotFoundRedirect.path, element: null },
  { path: authPages.otp.path, element: null },
  { path: authPages.eButtonService.path, element: null },
  { path: authPages.XMLResponse.path, element: null },
  { path: authPages.CreateEbuttonService.path, element: null },
  { path: authPages.DeleteButtonForm.path, element: null },
  { path: authPages.EditEbuttonService.path, element: null },
  { path: authPages.GetTransactionById.path, element: null },
  { path: authPages.GetTransactionByRefrenceNumber.path, element: null },
  { path: authPages.GetEbuttonTransactions.path, element: null },
  { path: "*", element: <DefaultFooter /> },
];

export default footers;
